
<div class="approval-list__card">
  <table mat-table matSort [dataSource]="dataSource">

    <ng-container matColumnDef="Details" >
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="__view_heading" > Details </th>
      <td mat-cell *matCellDef="let element">
        <div class="approval-list__title">Name: {{element.Details}}</div>
        <div class="approval-list__subtitle">Type: {{element.Type}}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="ApprovalFor">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="__view_heading"> Approval For </th>
      <td mat-cell *matCellDef="let element"><span class="approval-list__chip">{{element.ApprovalFor}}</span></td>
    </ng-container>

    <ng-container matColumnDef="RequestedBy">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Requested by </th>
      <td mat-cell *matCellDef="let element">
        <span class="approval-list__requested">
          <mat-icon class="approval-list__requested-icon">person</mat-icon>{{element.RequestedBy}}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="History" >
      <th mat-header-cell *matHeaderCellDef> History </th>
      <td mat-cell *matCellDef="let element"><img class="__icon" src="./../../../assets/img/history_icon.png" alt=""></td>
    </ng-container>

    <ng-container matColumnDef="Action">
      <th mat-header-cell *matHeaderCellDef> Action </th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item>
            <mat-icon>dialpad</mat-icon>
            <span>Redial</span>
          </button>
          <button mat-menu-item>
            <mat-icon>notifications_off</mat-icon>
            <span>Disable alerts</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</div>